export function transformInputListeners(attrs: Record<string, any>) {
    const retrieveValue = (element: HTMLInputElement) => {
        if (element.getAttribute('type') === 'number') {
            return element.valueAsNumber
        }

        if (element.getAttribute('type') === 'checkbox') {
            return element.checked
        }

        return element.value
    }

    const targetValueEmitter = (name: string) => (e: Event) => {
        const target = e.target as HTMLInputElement
        return attrs[`on${name.charAt(0).toUpperCase()}${name.slice(1)}`]?.(retrieveValue(target))
    }

    return {
        input: targetValueEmitter('input'),
        change: targetValueEmitter('change')
    }
}
